import { axios } from '@/services/axios';

const getSpecialNumbers = async () => {
    const res = await axios.get('/specialnumbers/');
    return res.data;
};

export default getSpecialNumbers;
